import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import * as ThemeQueryField from 'marketplace-ui-assets-core/constants/ThemeQueryField';
import * as PlanType from 'marketplace-ui-common/constants/pricings/PlanType';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import { Fragment, useCallback, useEffect, useState } from 'react';
import includes from '../../../utils/includes';
import PriceRangeInput from './PriceRangeInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ALL_PLAN_TYPES_VALUE = '__ALL_PLAN_TYPES__';
const CUSTOM_PRICE_RANGE_VALUE = '__CUSTOM_PRICE_RANGE__';
const INTERNAL_VALUES = [ALL_PLAN_TYPES_VALUE, CUSTOM_PRICE_RANGE_VALUE];
let cachedOptions;
const getOptions = () => {
  if (!cachedOptions) {
    cachedOptions = [{
      text: unescapedText('marketplace-assets-ui.assets.filters.price.all'),
      value: ALL_PLAN_TYPES_VALUE
    }, {
      text: unescapedText('marketplace-assets-ui.assets.filters.price.free'),
      value: PlanType.FREE
    }, {
      text: unescapedText('marketplace-assets-ui.assets.filters.price.paid'),
      value: PlanType.ONE_TIME
    }, {
      text: unescapedText('marketplace-assets-ui.assets.filters.price.custom'),
      value: CUSTOM_PRICE_RANGE_VALUE
    }];
  }
  return cachedOptions;
};
export default function PriceFilter({
  disabled,
  name,
  onPlanTypeChange,
  onPriceRangeChange,
  planTypeValue,
  priceRangeValue
}) {
  const [showCustomRange, setShowCustomRange] = useState(priceRangeValue !== null);
  const isCustom = Boolean(priceRangeValue || showCustomRange);
  const handleOnChange = useCallback(event => {
    const value = event.target.value;
    setShowCustomRange(value === CUSTOM_PRICE_RANGE_VALUE);
    const newValue = includes(INTERNAL_VALUES, value) ? null : value;
    onPlanTypeChange(ThemeQueryField.PLAN_TYPE, newValue);
  }, [onPlanTypeChange]);
  useEffect(() => {
    if (priceRangeValue === null) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setShowCustomRange(false);
    }
  }, [priceRangeValue]);
  useEffect(() => {
    if (!showCustomRange && priceRangeValue !== null) {
      onPriceRangeChange(ThemeQueryField.PRICE_RANGE, null);
    }
  }, [onPriceRangeChange, priceRangeValue, showCustomRange]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(FilterToggleGroup, {
      ariaLabel: unescapedText('marketplace-assets-ui.assets.filters.price.title'),
      disabled: disabled,
      multi: false,
      name: name || ThemeQueryField.PLAN_TYPE,
      onChange: handleOnChange,
      options: getOptions(),
      value: planTypeValue || isCustom && CUSTOM_PRICE_RANGE_VALUE || ALL_PLAN_TYPES_VALUE
    }), showCustomRange && /*#__PURE__*/_jsx(PriceRangeInput, {
      onFilterChange: onPriceRangeChange,
      priceRangeValue: priceRangeValue
    })]
  });
}
export function PriceFilterSubtitle({
  planTypeValue,
  priceRangeValue
}) {
  if (!planTypeValue && !priceRangeValue) return null;
  let key;
  if (planTypeValue === PlanType.FREE) key = 'marketplace-assets-ui.assets.filters.price.free';else if (planTypeValue === PlanType.ONE_TIME) key = 'marketplace-assets-ui.assets.filters.price.paid';else key = 'marketplace-assets-ui.assets.filters.price.custom';
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: key
  });
}